import { ThemeDefinition, VuetifyOptions } from 'vuetify';

// generic colors to avoid repeating the same colors in different color properties
const blackColor = '#212121';
const brandRedColor = '#E40613';
const primaryVioletColor = '#073855';
const whiteColor = '#FFFFFF';
// lightest(0) to darkest(999) grey colors
const grey700Color = '#4A4A4A';
const grey500Color = '#979797';
const grey300Color = '#BFBFBF';
const grey200Color = '#D4D4D4';
const dpmpLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#D50000',
    info: '#2196F3',
    primary: primaryVioletColor,
    secondary: whiteColor, // complementary color for primary, used for example for active shopping cart button in toolbar
    success: '#388E3C',
    warning: '#FB6B18',
    // background is primary visible in unauthorized pages since we're using cards (surface) on most auth pages as wrapper
    background: grey200Color,
    // variables with prefix 'on-' are used for text/content color. Example: 'on-background' is used
    // for text color on 'background'. Vuetify is doing solid work for generating on-colors based
    // on the color property. However for some tenants we need to override the default on-colors.
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor, // contrast color used for footer and some texts
    systemPrimary: brandRedColor, // all toolbars in dialogs and unauthorized pages
    systemToolbar: brandRedColor, // application toolbar background at the top
    navigationDrawer: brandRedColor, // active icons in menu
    neutral: grey500Color, // neutral colors used for example in system toolbar buttons
    'neutral-light': whiteColor, // neutral colors used for example in system toolbar buttons
    'neutral-border': grey300Color, // neutral colors used for example in system toolbar buttons
    'on-navigationDrawer': grey700Color, // non-active icons in menu
    'on-systemToolbar': whiteColor, // text color in system toolbar
  },
  variables: {
    'button-prepend-svg-height': '36px',
    'button-prepend-svg-width': '36px',
    'button-prepend-svg-margin': '-4px',
  },
};

export const dpmpTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: dpmpLightTheme,
  },
};
